import Loading from "component/Loading";
import { useLoginInfo } from "hook/loginInfo";
import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { api_commonFetch } from "util";

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){

    const navigate = useNavigate();
    const date = new Date();
    const nextDate = new Date(date.getFullYear(), date.getMonth()+1, 0);
    const [params, setParams] = useSearchParams();
    const [vo, setVO] = useState({
        name : params.get('name') || ''
        , gNo : params.get('gNo') || ""
    });
    const [loading, setLoading] = useState(true);
    const loginInfo = useLoginInfo();

    const [girlsList, setGirlsList] = useState([]);
    const [girlsImgList, setGirlsImgList] = useState([]);

    const fn_search = ()=>{
        const form = document.searchForm;
        const tmp = {
            ...vo
            , name : form.name.value
        }
        setVO(tmp);
        navigate('/girls?' + new URLSearchParams(tmp));

        document.querySelector(".scroll-100vh").scrollTo({
            top:0, 
            behavior:"smooth"
        });

    }

    const fn_getGirlsList = async()=>{
        const url = process.env.REACT_APP_API_URL + '/girls'
        const config = {method : 'get', headers : {Authorization : "Bearer " + sessionStorage.getItem('accessToken')}, credentials:'include'}
        const data = await api_commonFetch(url, config);
        const tmpList = data.girlsList;
        const girlsList = [];
        let dup = "";

        if(tmpList!=null && tmpList.length>0){
            tmpList.forEach((ob, i)=>{
                if(dup.indexOf(ob.name.trim()) == -1){
                    girlsList.push(ob);
                    dup += "," + ob.name.trim();
                }
            })
        }

        setGirlsList(girlsList);

    }

    const fn_getGirlsImgList = async()=>{
        setLoading(true);
        const url = process.env.REACT_APP_API_URL + '/girlsDataList?' + new URLSearchParams(vo);
        const config = {method : 'get', headers : {Authorization : "Bearer " + sessionStorage.getItem('accessToken')}, credentials:'include'}
        const data = await api_commonFetch(url, config);
        setGirlsImgList(data.girlsDataList);
        setLoading(false);
    }

    useEffect(()=>{
        if(loginInfo.memberId == 'rhzhzh3'){
            fn_getGirlsList();
        }
    }, []);

    useEffect(()=>{
        if(loginInfo.memberId == 'rhzhzh3'){
            fn_getGirlsImgList();
        }
    }, [vo]);

    return (
        <>

            <form name="searchForm" className="search-form" onSubmit={(e)=>{fn_search(); e.preventDefault();}}>
                <select name="name" value={vo.name} onChange={(e)=>{fn_search();}}>
                    <option value="">선택</option>
                {
                    girlsList!=null && girlsList.length>0 ? (
                        girlsList.map((ob, i)=>{
                            return (
                                <option key={ob.gNo} value={ob.name}>{ob.name}</option>
                            );
                        })
                    ) : ''
                }
                </select>
            </form>

            <div className="scroll-100vh">
                <table className="table">
                    <tbody>
                    {
                        girlsImgList!=null && girlsImgList.length>0 ? (
                            girlsImgList.map((ob, i)=>{
                                return (
                                    <tr key={ob.no}>
                                        <td>
                                            <img src={"https://crizel.duckdns.org/" + ob.img}/>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={99}>데이터가 없습니다.</td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </div>
        </>
    );

}